/*
 * @Author: huxiaohui 826564596@qq.com
 * @Date: 2025-06-30 15:49:20
 * @LastEditors: huxiaohui 826564596@qq.com
 * @LastEditTime: 2025-07-25 11:32:54
 * @FilePath: \client-h5\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Router from "vue-router";
import modules from "./module";
import Vue from "vue";
import { Toast } from "vant";
import { wxAuth } from "@/libs/wxAuth";
import store from "../store/index";
import { consumeAndShareCard } from "weixin-js-sdk";

Vue.use(Router);
if (window.history && window.history.pushState) {
    window.onpopstate = function () { };
}
const router = new Router({
    base: process.env.NODE_ENV === "production" ? "/qggzh" : "/",
    routes: [...modules],
    mode: "history",
});

/**
 * 权限判断,根据token判断是否有鉴权
 */
router.beforeEach((to, from, next) => {
    //从小程序跳转而来,会携带token而来 to.query={type:"miniProgram",token:'xxx',userId:'xxx' openId:"xxx"}
    if (to.query.type === "miniProgram") {
        localStorage.setItem("token", to.query.token);
        localStorage.setItem("userId", to.query.userId);
        localStorage.setItem("openId", to.query.openId);
        localStorage.setItem("givingCouponsNum", to.query.givingCouponsNum); //优惠券个数

        // wxAuth();

        // store.dispatch("getUserInfo");
    }
    //
    if (to.path == "/record" || to.path == "/mine" || to.path == "/pay/quickPay" || to.path == "/myCar") {
        if (!localStorage.getItem("userId")) {
            wx.miniProgram.redirectTo({
                url: `/pages/login/login?type=loginout`,
            });
        }
    }
    handleTitle(to);
    store.dispatch('checkIsLogin').then(res => {
        next()
    })
});

/**
 * 更换document的title
 * @param {*} to
 */
const handleTitle = (to) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
};

/**
 * 缓存页面
 * @param {*} to
 */
const handleKeepAlive = (to) => {
    console.log(to.matched);
};
export default router;
